<template>
  <v-container fluid>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>集計表示一覧（個人別）</template>
      <template v-slot:annotation
        >評価が完了しているスタッフ様について、評価の集計を個人別に表示することができます</template
      >
    </PageHeader>

    <v-row class="pl-3 pr-0">
      <v-col v-if="isDepartmentActive" cols="12" md="4">
        <v-select
          label="部署"
          v-model="department"
          item-text="label"
          item-value="value"
          :items="departmentItems"
          dense
          return-object
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          label="優先順位"
          v-model="userRank"
          item-text="label"
          item-value="value"
          :items="userRankItems"
          dense
          return-object
        />
      </v-col>
      <v-col cols="12" md="2">
        <FormInputComponent
          label="氏名"
          v-model="userNameSearch"
          :length="10"
        />
      </v-col>
      <v-col cols="2">
        <Button @click="get_evaluation()" color="primary">検索</Button>
      </v-col>
    </v-row>

    <v-row class="pl-2 pr-0">
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="評価情報は見つかりませんでした。新たに検索条件を設定してください。"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <DialogMessage ref="dialog" />
    <Loader :loading="loading" />
  </v-container>
</template>

<script>
import config from '@/const.js';
import axios from 'axios';
import message from '@/message.js';
import { getSessionStorageItem, convertEvaluationStatus } from '@/common.js';
export default {
  components: {},
  name: 'SumPerson',

  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: '集計表示一覧（個人）',
          route: 'SumPerson',
        },
      ],
      loading: false,
      confirm: false,
      isDepartmentActive: false,
      searchKey: '',

      userInfo: {},

      items: [],
      department: {},
      departmentItems: [],
      userRank: {},
      userRankItems: [],
      userItems: [],
      userNameSearch: '',

      headers: [
        {
          text: '部署',
          value: 'DEPARTMENT_NAME',
        },
        {
          text: '役職',
          value: 'POSITION_NAME',
        },
        {
          text: '氏名',
          value: 'USER_NAME',
        },
        {
          text: '年度名称',
          value: 'PERIOD_NAME',
        },
        {
          text: '人間力(%)',
          value: 'HUMAN_POWER_RATE',
          align: 'right',
        },
        {
          text: 'チャレンジ(%)',
          value: 'CHALLENGE_GOAL_RATE',
          align: 'right',
        },
        {
          text: '人間力合計',
          value: 'HUMAN_POWER_SCORE',
          align: 'right',
        },
        {
          text: 'チャレンジ合計',
          value: 'CHALLENGE_GOAL_SCORE',
          align: 'right',
        },
        {
          text: '評価点数',
          value: 'EVALUATION_SCORE',
          align: 'right',
        },
        {
          text: '評価',
          value: 'RANK_SETTING_NAME',
          width: '10%',
        },
      ],
      hasPeriod: false,
      initPeriodId: '',
    };
  },

  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
    if (userInfo) {
      this.userRank = userInfo.USER_RANK;
      if (
        this.userRank == config.USER_RANK_TOP ||
        this.userRank == config.USER_RANK_M ||
        this.userRank == config.USER_RANK_SYSOP
      ) {
        // TopとMの場合
        this.isDepartmentActive = true;
      } else {
        // 上記以外
        this.isDepartmentActive = false;
      }
    }
    // 部署情報の設定
    this.get_department();
    // ユーザランク情報の設定
    this.get_userRank();
  },

  methods: {
    async get_evaluation() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        return;
      }

      // 検索条件
      var searchConditionCount = 0;

      // 部署
      if (this.isDepartmentActive) {
        var departmentKey = this.department.value;
        if (!departmentKey) {
          departmentKey = config.EMPTY_STRING;
        } else {
          searchConditionCount++;
        }
      } else {
        departmentKey = userInfo.DEPARTMENT_KEY;
      }

      // ユーザランク
      var userRank = this.userRank.value;
      if (!userRank) {
        userRank = config.EMPTY_STRING;
      } else {
        searchConditionCount++;
      }
      // 氏名
      var userName = this.userNameSearch;
      if (!userName) {
        userName = config.EMPTY_STRING;
      } else {
        searchConditionCount++;
      }

      if (searchConditionCount == 0) {
        this.$refs.dialog.open(
          'info',
          '検索条件が一つも選択されていません。どれか一つの条件を選択してください。'
        );
        return;
      }

      // ログインユーザランク
      var loginUserRannk = userInfo.USER_RANK;
      if (userInfo.USER_RANK == config.USER_RANK_SYSOP) {
        // シスオペでログインした場合、TOP権限で検索
        loginUserRannk = config.USER_RANK_TOP;
      }

      let vm = this;
      this.loading = true;

      // ランク取得
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/rank/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // ランク設定データ取得
          vm.rankItems = response.data;

          axios
            .get(
              config.CONNECT_EVALUATIONS_URL +
                '/Evaluations/sum/person/' +
                userInfo.SESSION_ID +
                '/' +
                userInfo.USER_ID +
                '/' +
                userInfo.ORGANIZATION_KEY +
                '/' +
                departmentKey +
                '/' +
                userRank +
                '/' +
                userName +
                '/' +
                loginUserRannk
            )
            .then((response) => {
              // スタッフデータ取得
              vm.items = response.data;
              // 評価データ取得
              vm.items = response.data;
              for (var i = 0; i < vm.items.length; i++) {
                // 状態
                vm.items[i].STATUS = convertEvaluationStatus(
                  vm.items[i].EVAL_STATUS
                );
                // ランク設定
                var finalScore = Number(vm.items[i].EVALUATION_SCORE);
                for (var j = 0; j < vm.rankItems.length; j++) {
                  var rankScoreStart = Number(vm.rankItems[j].RANK_SCORE_START);
                  var rankScoreEnd = Number(vm.rankItems[j].RANK_SCORE_END);
                  if (
                    finalScore >= rankScoreStart &&
                    finalScore <= rankScoreEnd
                  ) {
                    vm.items[i].RANK_SETTING_NAME =
                      vm.rankItems[j].RANK_SETTING_NAME;
                    break;
                  }
                }
              }
            })
            .catch((error) => {
              let errStr = '';
              if (error.status == 400) {
                errStr = message.MSG_ERROR_SESSION + error;
                this.$refs.dialog.open('error', errStr);
              } else {
                errStr = message.MSG_ERROR_SYTEM + error;
                this.$refs.dialog.open('error', errStr);
              }
            })
            .finally(() => {
              // ローディング画像終了
              this.loading = false;
            });
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    async get_userRank() {
      // ローディング画像表示
      this.loading = true;

      var emptyItem = { label: '', value: '' };
      this.userRankItems.push(emptyItem);

      if (
        this.userRank == config.USER_RANK_TOP ||
        this.userRank == config.USER_RANK_SYSOP
      ) {
        // M
        var itemM = {
          label: this.userInfo.USER_RANK_NAME_2,
          value: config.USER_RANK_M,
        };
        this.userRankItems.push(itemM);
        // S
        var itemS = {
          label: this.userInfo.USER_RANK_NAME_3,
          value: config.USER_RANK_S,
        };
        this.userRankItems.push(itemS);
        // J
        var itemJ = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ);
        // E
        var itemE = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE);
      } else if (this.userRank == config.USER_RANK_M) {
        // S
        var itemS_M = {
          label: this.userInfo.USER_RANK_NAME_3,
          value: config.USER_RANK_S,
        };
        this.userRankItems.push(itemS_M);
        // J
        var itemJ_M = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ_M);
        // E
        var itemE_M = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_M);
      } else if (this.userRank == config.USER_RANK_S) {
        // J
        var itemJ_S = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ_S);
        // E
        var itemE_S = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_S);
      } else if (this.userRank == config.USER_RANK_J) {
        // E
        var itemE_J = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_J);
      }

      // ローディング画像終了
      this.loading = false;
    },
    async get_department() {
      // 部署情報取得
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/department/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 部署データ取得
          this.departmentItems = [];
          var emptyItem = { label: '', value: '' };
          this.departmentItems.push(emptyItem);
          vm.tmpItems = response.data;
          for (let i = 0; i < vm.tmpItems.length; i++) {
            var item = {
              label: vm.tmpItems[i].DEPARTMENT_NAME,
              value: vm.tmpItems[i].DEPARTMENT_KEY,
            };
            this.departmentItems.push(item);
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
  },
};
</script>
